import { CheckableTagProps } from "antd/lib/tag";
import React, { ForwardedRef } from "react";
import { theme } from "../../../../../theme";
import { CheckRoundTag, ReadonlyRoundTag } from "./CheckableTag.styled";

interface CheckableTagFormProps extends CheckableTagProps {
  readonly?: boolean;
}

export const CheckableTagForm = React.forwardRef(
  ({ readonly, ...props }: CheckableTagFormProps, ref: ForwardedRef<any>) => (
    <div ref={ref}>
      {readonly === false && <CheckRoundTag {...props} />}
      {readonly === true && (
        <ReadonlyRoundTag
          color={props.checked ? theme.colors.mainPrimary3 : undefined}
        >
          {props.children}
        </ReadonlyRoundTag>
      )}
    </div>
  )
);
